import React, {useEffect, useState} from 'react';
import "./Admin.css"
import {WorkShopItem} from "./Workshop";
import ReactQuill from "react-quill";
import 'react-image-picker/dist/index.css'
import {Link, Route, Routes, useLocation} from "react-router-dom";
import {CreationElement} from "../components/Creations";

const modules = {
    toolbar: [
        [{header: [1, 2, 3, 4, 5, 6]}],
        ["italic", "underline", "strike", "blockquote"],
        [{list: "ordered"}, {list: "bullet"}],
        ["link"],
    ]
};

const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet"
]
const URL: string = process.env.NODE_ENV === 'production' ? '/api/' : "http://192.168.1.4:3001/";

async function postApi(url: string, data: any, token?: string) {
    let headers = new Headers();
    headers.set('Content-Type', 'application/json');
    if (token) {
        headers.set('Authorization', `Bearer ${token}`);
    }
    return await (await fetch(`${URL}${url}`, {headers, method: 'POST', body: JSON.stringify(data)})).json();
}

const BASE_PATH = {api: URL + 'images', public: ''}

interface IImage {
    url: string;
    title: string;
    type: 'api' | 'public';
}

interface IWorkshop {
    title: string;
    description: string;
    subtitle: string;
    image: IImage;
}

interface ICreation {
    title: string;
    description: string;
    price: string;
    images: IImage[];
    position: number
}

function Admin() {
    const a = useLocation();
    const [adminData, setAdminData] = useState<any>({});
    const [editedIndex, setEditedIndex] = useState<Number | null>(null);
    const [editedCreationIndex, setEditedCreation] = useState<Number | null>(null);
    const [validToken, setValidToken] = useState<boolean>(false);
    const [token, setToken] = useState<string>('');
    const [editedMarket, setEditedMarket] = useState<string>('');
    const [logs, setLogs] = useState<{ login: string, password: string }>({login: '', password: ''});
    const [file, setFile] = useState<File | null>();
    const [filePreview, setFilePreview] = useState<any>();

    function fetchDataFromApi() {
        let fetchData = async () => {
            let data = await (await fetch(URL + 'data')).json();
            setAdminData(data)
            setEditedMarket(data.markets || '')
        }
        fetchData()
    }

    useEffect(() => {
        if (validToken) {
            fetchDataFromApi();
        }

    }, [token, validToken]);

    useEffect(() => {
        if (!validToken && token) {
            let headers = new Headers();
            headers.set('Authorization', `Bearer ${token}`);
            fetch(URL + 'auth/auth', {headers}).then(e => {
                e.text().then(w => {
                    if (w === 'ok') {
                        setValidToken(true)
                    }
                })
            })
        }
    }, [token])
    useEffect(() => {
        const storedToken = localStorage.getItem("token");
        if (storedToken) {
            setToken(storedToken)
        }
    }, []);
    return (
        <>
            {!validToken && <div>
                <label htmlFor={"login"}>Login</label>
                <input onChange={({target: {value}}) => {
                    setLogs({...logs, login: value})
                }} value={logs.login} type={"text"} id="login"/>
                <label htmlFor={"login"}>Mot de passe</label>
                <input onChange={({target: {value}}) => {
                    setLogs({...logs, password: value})
                }} value={logs.password} type={"password"} id="password"/>
                <button onClick={() => {
                    postApi('auth/login', logs).then(e => {
                        if (e?.access_token) {
                            setToken(e?.access_token)
                            localStorage.setItem("token", e?.access_token)
                        }
                    });

                }}> Envoyer
                </button>
            </div>}
            {validToken && <div className="Admin">
                <div style={{display: "flex", flexDirection: "row", width: "100%", justifyContent: "space-around"}}>
                    <Link to={'/admin/workshop'}> Ateliers</Link>
                    <Link to={'/admin/creations'}> Creations</Link>
                    <Link to={'/admin/markets'}>Oû me trouver</Link>

                </div>

                <>
                </>
                <br/>
                Choisir une image à ajouter au serveur
                <br/>
                <input type="file" onChange={(e) => {

                    const file = e?.target?.files?.[0];
                    if (file) {
                        setFile(file);

                        setFilePreview(window.URL.createObjectURL(file))

                    }
                }
                }/>
                <br/>
                <img src={filePreview} alt="" className="image-preview" width={"100px"}/>
                <br/>
                <button onClick={() => {
                    if (file) {

                        var data = new FormData()
                        data.append('image', file)


                        let headers = new Headers();
                        headers.set('Authorization', `Bearer ${token}`);
                        fetch(`${URL}upload/image`, {
                            method: 'POST',
                            body: data,
                            headers,
                        }).then(async (e) => {
                            fetchDataFromApi()
                            setFile(null)
                        })
                    }

                }} disabled={!file}> Ajouter l'image
                </button>
                <br/>

                <Routes>
                    <Route path={'markets'} element={<>

                        <div style={{
                            textAlign: "center",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center"
                        }}>

                            <div dangerouslySetInnerHTML={{__html: editedMarket}}>

                            </div>
                        </div>
                        <ReactQuill
                            className="quill"
                            // theme="snow"
                            modules={modules}
                            formats={formats}
                            placeholder={"Marché ou me trouver"}
                            value={editedMarket}
                            onChange={(e) => {
                                if (e !== editedMarket) {
                                    setEditedMarket(e)

                                }
                            }}
                        />
                        <div>
                            <button
                                onClick={() => {
                                    postApi('data/updateMarkets', {markets: editedMarket}, token).then(e => {
                                        fetchDataFromApi()
                                    })
                                }}
                                disabled={adminData?.markets === editedMarket}>Sauvegarder
                            </button>

                        </div>
                    </>}/>
                    <Route path={'workshop'} element={<>
                        {adminData?.workshops?.map((e: IWorkshop, i: Number) => <span
                                key={`ws${i}`}
                            >
                    {editedIndex !== i && <><WorkShopItem
                            subtitle={e.subtitle}
                            title={e.title}
                            description={e.description}
                            image={{
                                url: e.image ? `${BASE_PATH[e.image?.type]}/${e?.image?.url}` : '',
                                title: e?.image?.title
                            }}
                        />
                            <button title={"edit"} onClick={() => {
                                setEditedIndex(i)
                            }}>Modifier
                            </button>
                            <button title={"delete"} onClick={() => {
                                let confirmValue = window.confirm(`Supprimer l'atelier : ${e.title}`)
                                if (confirmValue) {
                                    postApi('data/deleteWorkshop', {idx: i}, token).then(() => {
                                        fetchDataFromApi()
                                    })

                                }
                            }}>supprimer
                            </button>
                            <br/>
                            <br/>
                            <hr style={{border: "1px solid #ccc"}}/>
                        </> ||
                        <EditWorkshop data={e} images={adminData.images}
                                      cancelEdit={() => {
                                          setEditedIndex(null)
                                      }}
                                      onSave={(edited) => {
                                          postApi('data/editWorkshop', {...edited, idx: editedIndex}, token).then(e => {
                                              setEditedIndex(null)
                                              fetchDataFromApi()

                                          })
                                          // setAdminData({
                                          //     ...adminData,
                                          //     workshops: adminData.workshops.map((e: any, x: Number) => x === i ? edited : e)
                                          // })
                                          // setEditedIndex(null)

                                      }}/>
                    }

            </span>
                        )}
                        <br/>
                        <br/>
                        <br/>
                        <button onClick={() => {
                            let confirmVal = window.confirm('Ajouter un Atelier?');
                            if (confirmVal) {
                                postApi('data/addWorkshop',
                                    {
                                        image: adminData?.images?.[0],
                                        title: "Titre",
                                        subtitle: "Sous Titre",
                                        description: "Description"

                                    }

                                    , token).then(() => fetchDataFromApi())

                            }

                        }}>
                            Ajouter un Atelier
                        </button>
                        <br/></>}/>
                    <Route path={'creations'} element={<>
                        {

                        }
                        <div className="Creation">
                            <div className="CreationContainer">
                                <button onClick={() => {
                                    let confirmVal = window.confirm('Ajouter une Creation?');
                                    if (confirmVal) {
                                        postApi('data/addCreation',
                                            {
                                                images: [],
                                                title: "Titre",
                                                prix: "Prix",
                                                description: "Description"

                                            }
                                            , token).then(() => fetchDataFromApi())

                                    }

                                }}>
                                    Ajouter une Creation
                                </button>
                                <section id={`scrollTo${-1}`}></section>
                                {adminData?.creations?.map((c: any, i: number) => <span key={'crea' + i}>{
                                    editedCreationIndex !== i && <>
                                        <CreationElement images={c.images.map((e: IImage) => ({
                                            url: `${BASE_PATH[e.type]}/${e.url}`,
                                            title: e.title
                                        }))} title={c.title} description={c.description} price={c.price}/>
                                        <div>

                                            <br/>
                                            <br/>
                                            <button onClick={() => {
                                                setEditedCreation(i)
                                                const el = document.getElementById(`scrollTo${i - 1}`);
                                                window.scrollTo({
                                                    top: el?.offsetTop
                                                });
                                            }}>Modifier
                                            </button>
                                            <button onClick={() => {
                                                let confirmValue = window.confirm(`Supprimer la creation : ${c.title}`)
                                                if (confirmValue) {
                                                    postApi('data/deleteCreation', {idx: i}, token).then(() => {
                                                        fetchDataFromApi()
                                                    })

                                                }
                                            }}>supprimer
                                            </button>
                                            <br/>
                                            <br/>
                                        </div>

                                        <hr style={{width: '100%', border: "1px solid #ccc"}}/>
                                        <section id={`scrollTo${i}`}></section>
                                    </> || <EditCreation cancelEdit={() => {
                                        setEditedCreation(null)
                                    }} onSave={(edited) => {

                                        if (!isNaN(edited.position) && edited.position !== i) {
                                            let tosend = {...edited};
                                            delete tosend.position;
                                            postApi('data/editCreation', {...tosend, idx: i}, token).then(() => {
                                                fetchDataFromApi()
                                                setEditedCreation(null)
                                            }).then(e => {
                                                postApi('data/reorderCreation', {
                                                    creationIdx: i,
                                                    position: edited.position
                                                }, token).then(() => fetchDataFromApi())
                                            })

                                        } else {
                                            postApi('data/editCreation', {...edited, idx: i}, token).then(() => {
                                                fetchDataFromApi()
                                                setEditedCreation(null)
                                            })

                                        }

                                    }}
                                                         index={i}
                                                         max={adminData?.creations?.length}
                                                         images={adminData.images} data={c}/>
                                }</span>)}

                            </div>
                        </div>

                    </>}/>
                </Routes>


            </div>
            }  </>);
}

function EditWorkshop({data, onSave, cancelEdit, images}: {
    data: any,
    cancelEdit: () => void,
    onSave: (e: any) => void,
    images: any[]
}) {
    const [edited, setEdited] = useState<IWorkshop>(data);
    return <div>

        <div>

            title
            <ReactQuill
                className="quill"
                // theme="snow"
                modules={modules}
                formats={formats}
                placeholder={"Titre"}
                value={edited.title}
                onChange={(e) => {
                    if (e !== edited.title) {
                        setEdited({...edited, title: e})

                    }
                }}
            />
        </div>
        <div>
            Sous titre
            <ReactQuill
                // theme="snow"
                className="quill"
                modules={modules}
                formats={formats}
                placeholder={"Sous titre"}
                value={edited.subtitle}
                onChange={(e) => {
                    if (e !== edited.subtitle) {
                        setEdited({...edited, subtitle: e})

                    }
                }
                }
            />
        </div>
        <div>

            Description
            <ReactQuill
                className="quill"
                // theme="snow"
                modules={modules}
                formats={formats}
                placeholder={"Description"}
                value={edited.description}
                onChange={(e) => {
                    if (e !== edited.description) {
                        setEdited({...edited, description: e})

                    }
                }}
            />
        </div>
        <div>

            Image

            <div style={{
                display: "grid",
                gridTemplateColumns: " repeat(auto-fill, minmax(75px, 1fr))",
                gap: "5px",
                flexDirection: "column",
                width: `100%`,
                height: "200px",
                overflowX: "hidden",
                overflowY: "scroll",
                border: 'solid 1px grey'
            }}>
                {images?.map((item: IImage, index: number) => <img onClick={() => {
                    setEdited({...edited, image: images.find(j => j.title === item?.title)})
                }} style={{
                    border: edited.image?.title === item.title ? 'solid 2px #2daaa7' : '',
                    objectFit: 'cover',
                    margin: "5px",
                    width: "75px",
                    display: 'flex'
                }} alt={item.title} src={`${BASE_PATH[item.type]}/${item.url}`}
                                                                   key={item?.title}/>)}
            </div>
            <img src={`${BASE_PATH[edited.image.type]}/${edited.image?.url}`} width={'10%'}/>


        </div>
        <button onClick={() => {
            cancelEdit()
        }}>Annuler
        </button>
        <button onClick={() => {
            onSave(edited)
        }}>Sauvegarder
        </button>
    </div>
        ;
}

function EditCreation({index, max, data, onSave, cancelEdit, images}: {
    data: any,
    cancelEdit: () => void,
    onSave: (e: any) => void,
    images: any[],
    index: number, max: number
}) {
    const [edited, setEdited] = useState<ICreation>(data);
    return <div>


        <div>

            title
            <textarea style={{width: '100%'}} value={edited.title}
                      onChange={({target: {value}}) => {

                          setEdited({...edited, title: value})


                      }}
            />
        </div>
        <div>

            Description
            <textarea style={{width: '100%'}} value={edited.description}
                      onChange={({target: {value}}) => {

                          setEdited({...edited, description: value})


                      }}
            />
        </div>
        <div>

            Prix
            <textarea style={{width: '100%'}} value={edited.price}
                      onChange={({target: {value}}) => {

                          setEdited({...edited, price: value})


                      }}
            />
        </div>
        <div>

            Images

            <div style={{
                display: "grid",
                gridTemplateColumns: " repeat(auto-fill, minmax(75px, 1fr))",
                gap: "5px",
                flexDirection: "column",
                width: `100%`,
                height: "200px",
                overflowX: "hidden",
                overflowY: "scroll",
                border: 'solid 1px grey'
            }}>
                {images?.map((item: IImage, index: number) => <div style={{textAlign: 'center', color: '#2daaa7'}}
                                                                   key={item.title}><img onClick={() => {
                    if (edited.images.find((e: IImage) => e.title === item.title)) {
                        setEdited({...edited, images: edited.images.filter(im => im.title !== item.title)})

                    } else {


                        setEdited({...edited, images: [...edited.images, images.find(j => j.title === item.title)]})
                    }
                }} style={{
                    border: edited.images.find(i => i.title === item.title) ? 'solid 2px #2daaa7' : '',
                    objectFit: 'cover',
                    margin: "5px",
                    width: "75px",
                    display: 'flex'
                }} alt={item.title} src={`${BASE_PATH[item.type]}/${item.url}`}
                                                                                         key={item?.title}/>
                    {edited.images.find(e => e.title === item.title) &&
                        <span>{edited.images.findIndex(e => e.title === item.title) + 1}</span>}
                </div>)}

            </div>
            {edited.images.map(im => <img src={`${BASE_PATH[im.type]}/${im.url}`} alt={im.title} width={'10%'}/>)}


        </div>
        <div>
            Position:
            <br/>
            <select defaultValue={index} onChange={({target: {value}}) => {
                console.log({value})
                setEdited({...edited, position: Number(value)})
            }}>
                {Array.apply(null, Array(max)).map((_, it) => {
                    return <option value={it}>{it + 1}</option>

                })}

            </select>

        </div>
        <button onClick={() => {
            cancelEdit()
        }}>Annuler
        </button>
        <button onClick={() => {
            onSave(edited)
        }}>Sauvegarder
        </button>
    </div>
        ;
}

export default Admin;
